import { BackgroundColorName } from '@/helpers/mapBackgroundColor';

export const getDefaultBackgroundColorName = (isOnDark: boolean): BackgroundColorName => {
  return isOnDark ? 'darkViolet' : 'lightViolet';
};
